import { getTaobaoItemListSku } from "@/api/jhk/analysis/ware-controller";
// 适用于新活动数据传参格式
// 保存活动入参
export const useInputBasicInformation = (that,subType) => {
  let ruleDTO = {
    ...that.ruleDTO,
    openCardFollow: that.ruleForm.openCardFollow,
    firstOpenCardTimeType: that.ruleForm.firstOpenCardTimeType,
    openCardBeforeDay: that.ruleForm.openCardBeforeDay,
    isForceRemind: that.isForceRemind,
  };
  let obj = {
    ...that.ruleForm,
    subType: subType,
    ruleDTO,
    pointActivityPrizeDTOList: [],
    isKeyActivity: that.isKeyActivity,
    placementPosition: that.placementPosition.join(","),
    isValidBlackList: that.ruleForm.isValidBlackList,
  };
  obj.condFollow = Number(that.ruleForm.condFollow);
  obj.ruleDTO.openCardStartTime =
    that.actMember == 2 ? that.ruleDTO.openCardStartTime : "";
  obj.ruleDTO.openCardEndTime =
    that.actMember == 2 ? that.ruleDTO.openCardEndTime : "";
  obj.ruleDTO.plusObject = that.ruleDTO.plusObject;
  // 其他活动页配置
  obj.ruleDTO.customerPaperwork = JSON.stringify(that.customerPaperwork);

  //曝光商品集合设置
  obj.priceType = 0;
  obj.isExposureItem = that.ruleForm.isExposureItem ? 1 : 0;
  obj.itemList = that.itemListFor;

  // 模板
  obj.templateJson = that.templateJson;
  obj.templateId = that.templateId;

  // 活动对象处理
  // 参与会员等级：-1(全部)，0(非会员)，其余填会员等级,
  obj.allowLevel =
    that.ruleForm.partner && that.ruleForm.partner.length
      ? that.ruleForm.partner.join(",")
      : "";

  if (that.actMember == 1) {
    obj.allowLevel = "-1";
  } else if (that.actMember == 3) {
    obj.allowLevel = "99";
    obj.crowdIds = that.peopleSelected.join(",");
  } else if (that.actMember == 2) {
    obj.allowLevel =
      that.ruleForm.partner && that.ruleForm.partner.length
        ? that.ruleForm.partner.join(",")
        : "";
    if (obj.allowLevel == "-1") {
      //会员等级设置
      let list = ["-1", "0"];
      that.levelList.forEach((item, index) => {
        let num = index + 1;
        list.push(num);
      });
      obj.allowLevel = list.join(",");
    }
  }
  obj.ruleDTO.orderCompleteLimitCount = that.ruleForm.orderCompleteLimitCount;
  obj.ruleDTO.orderCompleteMaxCount = that.ruleForm.orderCompleteMaxCount;
  obj.ruleDTO.orderCompleteLimitPayment =
    that.ruleForm.orderCompleteLimitPayment;
  obj.ruleDTO.orderCompleteMaxPayment = that.ruleForm.orderCompleteMaxPayment;
  obj.ruleDTO.lastOrderCompleteTimeType =
    that.ruleForm.lastOrderCompleteTimeType;
  if (obj.ruleDTO.lastOrderCompleteTimeType == 1) {
    obj.ruleDTO.lastOrderCompleteStartDay =
      that.ruleForm.lastOrderCompleteStartDay;
    obj.ruleDTO.lastOrderCompleteEndDay = that.ruleForm.lastOrderCompleteEndDay;
  } else if (obj.ruleDTO.lastOrderCompleteTimeType == 2) {
    obj.ruleDTO.lastOrderCompleteStartTime =
      that.ruleForm.lastOrderCompleteStartTime;
    obj.ruleDTO.lastOrderCompleteEndTime =
      that.ruleForm.lastOrderCompleteEndTime;
  }
  delete obj.partner;
  delete obj.openCardFollow;
  delete obj.firstOpenCardTimeType;
  delete obj.openCardBeforeDay;
  delete obj.orderCompleteLimitCount;
  delete obj.orderCompleteMaxCount;
  delete obj.orderCompleteLimitPayment;
  delete obj.orderCompleteMaxPayment;
  delete obj.lastOrderCompleteTimeType;
  delete obj.lastOrderCompleteStartDay;
  delete obj.lastOrderCompleteEndDay;
  delete obj.lastOrderCompleteStartTime;
  delete obj.lastOrderCompleteEndTime;
  return obj;
};
// 活动详情处理参数
export const useOutputBasicInformation = (data, that) => {
  const {
    activityName,
    startTime,
    endTime,
    ruleDto,
    isExposureItem,
    ruleDescription,
    allowLevel,
    crowdIds,
    condFollow,
    templateId,
    isKeyActivity,
    placementPosition,
    isValidBlackList,
    itemList,
    templateJson,
  } = data;
  const {
    openCardFollow,
    firstOpenCardTimeType,
    openCardBeforeDay,
    isForceRemind,
    customerPaperwork,
  } = ruleDto;
  that.ruleForm.activityName =
    activityName + (that.activityData.isCopy ? "复制" : "");
  that.ruleForm.condFollow = condFollow ? true : false;
  // 活动对象配置
  if (allowLevel == "99") {
    that.peopleSelected = crowdIds.split(",");
    that.actMember = "3";
  } else if (allowLevel == "-1") {
    that.actMember = "1";
    that.ruleForm.partner = ["-1"];
  } else {
    that.actMember = "2";
    if (allowLevel.indexOf("-1") != -1) {
      that.ruleForm.partner = ["-1"];
    } else {
      that.ruleForm.partner = allowLevel.split(",");
    }
  }
  that.ruleForm.openCardFollow = openCardFollow;
  that.ruleForm.isValidBlackList = isValidBlackList;
  that.ruleForm.firstOpenCardTimeType = firstOpenCardTimeType;
  that.ruleForm.openCardBeforeDay = openCardBeforeDay;
  that.ruleDTO = ruleDto;
  that.isForceRemind = isForceRemind;
  that.isKeyActivity = isKeyActivity || 0;
  that.placementPosition = placementPosition
    ? placementPosition.split(",")
    : ["SHOP"];
  that.ruleForm.orderCompleteLimitCount = ruleDto.orderCompleteLimitCount;
  that.ruleForm.orderCompleteMaxCount = ruleDto.orderCompleteMaxCount;
  that.ruleForm.orderCompleteLimitPayment = ruleDto.orderCompleteLimitPayment;
  that.ruleForm.orderCompleteMaxPayment = ruleDto.orderCompleteMaxPayment;
  that.ruleForm.lastOrderCompleteTimeType =
    ruleDto.lastOrderCompleteTimeType || 0;
  that.ruleForm.lastOrderCompleteStartDay = ruleDto.lastOrderCompleteStartDay;
  that.ruleForm.lastOrderCompleteEndDay = ruleDto.lastOrderCompleteEndDay;
  that.ruleForm.lastOrderCompleteStartTime = ruleDto.lastOrderCompleteStartTime;
  that.ruleForm.lastOrderCompleteEndTime = ruleDto.lastOrderCompleteEndTime;

  that.templateJson = JSON.parse(templateJson);
  if (customerPaperwork) {
    that.customerPaperwork = JSON.parse(customerPaperwork);
  }
  // v2.5 => 复制不需要回显奖品和规则
  if (!that.activityData.isCopy) {
    that.ruleForm.startTime = startTime;
    that.ruleForm.endTime = endTime;
    that.activityStartTime = startTime;
    that.activityEndTime = endTime;

    that.ruleForm.isExposureItem = isExposureItem ? true : false;
    that.itemListFor = itemList;
    that.ruleForm.ruleDescription = ruleDescription;
  }
  if (that.activityData.isCopy) {
    that.ruleForm.ruleDescription = "";
  }
  that.templateId = templateId;
};
// 修改活动入参
export const useUpdateBasicInformation = (obj, prizeListCommon, that) => {
  let params = {
    activityId: that.valueRow.id,
    ruleDescription: obj.ruleDescription,
    prizes: prizeListCommon
      .filter((item) => item.id)
      .map((item) => {
        return {
          ...item,
          prizeId: item.id,
        };
      }),
    isExposureItem: that.ruleForm.isExposureItem ? 1 : 0, //曝光商品
    itemList: that.ruleForm.isExposureItem ? that.itemListFor : [],
    activityName: obj.activityName,
    condFollow: obj.condFollow ? 1 : 0,
    ruleDto: obj.ruleDTO,
    templateId: that.templateId,
    endTime: that.ruleForm.endTime,
    isValidBlackList: obj.isValidBlackList,
    taskList: obj.taskList,
  };
  if(obj.subType==84) {
    params.firstItemList = that.firstItemList
  }
  return params;
};
// 重置活动对象信息
export const useResetMemberInfo = (that,key="ruleDTO") => {
  that.peopleSelected = [];
  that.ruleForm.partner = ["-1"];
  that.ruleForm.firstOpenCardTimeType = 0;
  that.ruleForm.openCardBeforeDay = "";
  that.ruleForm.orderCompleteLimitCount = "";
  that.ruleForm.orderCompleteMaxCount = "";
  that.ruleForm.orderCompleteLimitPayment = "";
  that.ruleForm.orderCompleteMaxPayment = "";
  that.ruleForm.lastOrderCompleteTimeType = 0;
  that.ruleForm.lastOrderCompleteStartDay = "";
  that.ruleForm.lastOrderCompleteEndDay = "";
  that.ruleForm.lastOrderCompleteStartTime = "";
  that.ruleForm.lastOrderCompleteEndTime = "";
  that[key].plusObject = 0;
  that[key].cusType = 0; //新老客类型
};

// 更多活动配置校验
export const useValidateMoreActSet = (that) => {
    // 更多活动设置
    if(that.customerPaperwork) {
      const moreActSet = that.customerPaperwork.moreActSet || {};
      if(moreActSet.isShowFloatWindow==1) {
        if(!moreActSet.floatWindowImg) {
          that.$message.warning("请上传浮窗图片");
          return;
        }
        if(moreActSet.goShopSetting==1&&!moreActSet.goShopAppId) {
          that.$message.warning("请完善跳转链接");
          return;
        }
        if (moreActSet.goShopSetting == 2) {
          if (!moreActSet.goShopUrl) {
            that.$message.warning("请完善跳转链接");
            return;
          } else if (
            !moreActSet.goShopUrl.startsWith("https://") ||
            !moreActSet.goShopUrl.includes("jd.com")
          ) {
            that.$message.warning(
              "浮窗图片跳转链接输入的内容非链接或为接口无法支持的链接，请重新设置"
            );
            return;
          }
        }
      }
      if(moreActSet.isShowBanner==1) {
        if(!moreActSet.bannerList.length) {
          that.$message.warning("请添加活动banner");
          return;
        }
      }
    }
    return true;
}

// 保存活动公共校验
export const useValidateBasicInformation = (that) => {
  if (!that.ruleForm.activityName) {
    that.$message.warning("请输入活动名称");
    return;
  }
  //活动时间的限制
  if (!that.ruleForm.startTime || !that.ruleForm.endTime) {
    that.$message.warning("请输入活动时间");
    return;
  }
  //活动对象限制
  if (
    that.actMember == 2 &&
    (!that.ruleForm.partner || that.ruleForm.partner.length == 0)
  ) {
    that.$message.warning("请选择活动对象");
    return;
  }
  if (that.actMember == 3 && !that.peopleSelected.length) {
    that.$message.warning("请选择指定人群");
    return;
  }

  // 1.14迭代 这里判断 指定入会时间
  if (that.actMember == "2") {
    if (
      that.ruleForm.firstOpenCardTimeType == 1 &&
      !that.ruleForm.openCardBeforeDay
    ) {
      that.$message.warning("请完善首次入会时间");
      return;
    }
    if (
      that.ruleForm.firstOpenCardTimeType == 2 &&
      (!that.ruleDTO.openCardStartTime || !that.ruleDTO.openCardEndTime)
    ) {
      that.$message.warning("请完善首次入会时间");
      return;
    }
    // 最后一次订单完成时间
    if (
      that.ruleForm.lastOrderCompleteTimeType == 1 &&
      !that.ruleForm.lastOrderCompleteEndDay &&
      !that.ruleForm.lastOrderCompleteStartDay
    ) {
      that.$message.warning("最后一次订单完成时间");
      return;
    }

    if (
      that.ruleForm.lastOrderCompleteTimeType == 2 &&
      !that.ruleForm.lastOrderCompleteStartTime &&
      !that.ruleForm.lastOrderCompleteEndTime
    ) {
      that.$message.warning("最后一次订单完成时间");
      return;
    }
  }
  return true;
};

// 奖品必填校验
export const useValidatePrizeInformation = (that, prizeKey) => {
  if (that[prizeKey].length == 0) {
    return that.$message.warning("请添加奖品");
  }
  const isHasVal = that[prizeKey].some(
    (item) => !item.title || !item.totalAmount || !item.prizeType
  );
  if (isHasVal) {
    that.$message.warning("请完善奖品信息");
    return;
  }
  return true;
};
// 活动公共字段后部分校验
export const useValidateActEndInfomation = (that,isShowShare = true) => {
  if (that.subType!=86&&!that.templateId) {
    that.$message.warning("请选择活动模板");
    return 
  }
  // 小程序分享标题
  if (!that.ruleDTO.shareTitle) {
    that.$message.warning("请输入小程序分享标题");
    return;
  }
  // 小程序分享简介
  if (!that.ruleDTO.shareIntroduce) {
    that.$message.warning("请输入小程序分享简介");
    return;
  }
  if (!that.ruleForm.ruleDescription) {
    that.$message.warning("请输入活动规则");
    return;
  }
  if (!useValidateMoreActSet(that)) {
    return;
  }
  //新增进店设置校验
  if (isShowShare && that.ruleDTO.goShopSetting == 1 && !that.ruleDTO.goShopAppId) {
    that.$message.warning("请输入小程序appId");
    return;
  }
  if (isShowShare && that.ruleDTO.goShopSetting == 2) {
    if (!that.ruleDTO.goShopUrl) {
      that.$message.warning("请输入指定链接");
      return;
    } else if (
      !that.ruleDTO.goShopUrl.startsWith("https://") ||
      !that.ruleDTO.goShopUrl.includes("jd.com")
    ) {
      that.$message.warning(
        "输入的内容非链接或为接口无法支持的链接，请重新设置"
      );
      return;
    }
  }
  if (that.ruleForm.isExposureItem && that.itemListFor.length == 0) {
    that.$message.warning("请选择曝光商品");
    return;
  }
  if (that.placementPosition.length == 0) {
    that.$message.warning("请选择活动投放位置！");
    return;
  }
  return true;
};
const formatTimeNumber = (num) => {
  return num < 10 ? `0${num}` : `${num}`;
};
// 时间倒计时钩子封装
export const useCountDownTime = (endTime, now =  Date.now()) => {
  const timeObj = {
    days: "00",
    hours: "00",
    minutes: "00",
    seconds: "00",
  };
  let timer = null;
  if (!endTime) {
    return;
  }
  const end = new Date(endTime).getTime();
  let diff = end - now;
  if (diff <= 0) {
    timeObj.days = "00";
    timeObj.hours = "00";
    timeObj.minutes = "00";
    timeObj.seconds = "00";
    clearInterval(timer);
    return;
  }
  const day = Math.floor(diff / (24 * 60 * 60 * 1000));
  diff = diff % (24 * 60 * 60 * 1000);
  const hour = Math.floor(diff / (60 * 60 * 1000));
  diff = diff % (60 * 60 * 1000);
  const minute = Math.floor(diff / (60 * 1000));
  diff = diff % (60 * 1000);
  const second = Math.floor(diff / 1000);
  timeObj.days = formatTimeNumber(day);
  timeObj.hours = formatTimeNumber(hour);
  timeObj.minutes = formatTimeNumber(minute);
  timeObj.seconds = formatTimeNumber(second);
  return timeObj;
};

export const initFrom = (that) => {
  let ruleDTO = {
    ...that.ruleDTO,
    openCardFollow: that.ruleForm.openCardFollow,
    firstOpenCardTimeType: that.ruleForm.firstOpenCardTimeType,
    openCardBeforeDay: that.ruleForm.openCardBeforeDay,
    isForceRemind: that.isForceRemind,
    isCheckImage:1,
    isCommentLimit: that.ruleForm.isCommentLimit,
  };
  let obj = {
    ...that.ruleForm,
    subType: 83,
    ruleDTO,
    pointActivityPrizeDTOList: [],
    isKeyActivity: that.isKeyActivity,
    placementPosition: that.placementPosition.join(","),
    isValidBlackList: that.ruleForm.isValidBlackList,
  }
  obj.condFollow = Number(that.ruleForm.condFollow);
  obj.condFollow = Number(that.ruleForm.condFollow);
  obj.ruleDTO.openCardStartTime =
    that.actMember == 2 ? that.ruleDTO.openCardStartTime : "";
  obj.ruleDTO.openCardEndTime =
    that.actMember == 2 ? that.ruleDTO.openCardEndTime : "";
  obj.ruleDTO.plusObject = that.ruleDTO.plusObject;
  // 其他活动页配置
  obj.ruleDTO.customerPaperwork = JSON.stringify(that.customerPaperwork);
  //曝光商品集合设置
  obj.priceType = 0;
  obj.isExposureItem = that.ruleForm.isExposureItem ? 1 : 0;
  obj.itemList = that.itemListFor;
  // 模板
  obj.templateJson = that.templateJson;
  obj.templateId = that.templateId;
  
  // 活动对象处理
  // 参与会员等级：-1(全部)，0(非会员)，其余填会员等级,
  obj.allowLevel = that.ruleForm.partner && that.ruleForm.partner.length ? that.ruleForm.partner.join(",") : "";
  if (that.actMember == 1) {
    obj.allowLevel = "-1";
  } else if (that.actMember == 3) {
    obj.allowLevel = "99";
    obj.crowdIds = that.peopleSelected.join(",");
  } else if (that.actMember == 2) {
    obj.allowLevel =
      that.ruleForm.partner && that.ruleForm.partner.length
        ? that.ruleForm.partner.join(",")
        : "";
    if (obj.allowLevel == "-1") {
      //会员等级设置
      let list = ["-1", "0"];
      that.levelList.forEach((item, index) => {
        let num = index + 1;
        list.push(num);
      });
      obj.allowLevel = list.join(",");
    }
  }
  obj.ruleDTO.orderCompleteLimitCount = that.ruleForm.orderCompleteLimitCount;
  obj.ruleDTO.orderCompleteMaxCount = that.ruleForm.orderCompleteMaxCount;
  obj.ruleDTO.orderCompleteLimitPayment =
    that.ruleForm.orderCompleteLimitPayment;
  obj.ruleDTO.orderCompleteMaxPayment = that.ruleForm.orderCompleteMaxPayment;
  obj.ruleDTO.lastOrderCompleteTimeType =
    that.ruleForm.lastOrderCompleteTimeType;
  if (obj.ruleDTO.lastOrderCompleteTimeType == 1) {
    obj.ruleDTO.lastOrderCompleteStartDay =
      that.ruleForm.lastOrderCompleteStartDay;
    obj.ruleDTO.lastOrderCompleteEndDay = that.ruleForm.lastOrderCompleteEndDay;
  } else if (obj.ruleDTO.lastOrderCompleteTimeType == 2) {
    obj.ruleDTO.lastOrderCompleteStartTime =
      that.ruleForm.lastOrderCompleteStartTime;
    obj.ruleDTO.lastOrderCompleteEndTime =
      that.ruleForm.lastOrderCompleteEndTime;
  }

  obj.ruleDTO.startCommentTime = that.ruleForm.startCommentTime;
  obj.ruleDTO.endCommentTime = that.ruleForm.endCommentTime;

  obj.ruleDTO.filterType = that.ruleForm.filterType;
  obj.ruleDTO.skuIdList = that.ruleForm.filterType == "0" ? "" : that.itemListForFilter.map((item) => item.skuId)
  obj.ruleDTO.scores = that.scores.join(",");
  obj.ruleDTO.wordNum = that.ruleForm.wordNum;
  obj.ruleDTO.imgNum = that.ruleForm.imgNum;
  obj.ruleDTO.videoNum = that.ruleForm.videoNum;
  obj.ruleDTO.isCommentFilter = that.ruleForm.isCommentFilter ? 1 : 0;
  if (that.ruleForm.isCommentFilter) {
    obj.ruleDTO.commentFilter = that.ruleForm.commentFilter;
  }else{
    obj.ruleDTO.commentFilter = "";
  }

  obj.ruleDTO.isReservedAddress = that.ruleForm.isReservedAddress ? 1 : 0;
  obj.ruleDTO.rankedOpenTiming = that.ruleForm.rankedOpenTiming;
  obj.ruleDTO.rankedOpenType = that.ruleForm.rankedOpenType;
  if(that.ruleForm.rankedOpenType == "0"){
    obj.ruleDTO.rankedLimit = that.ruleForm.rankedLimit;
  }

  obj.ruleDTO.showImageStepList = that.prizeSetting.map((item,index)=>{
    let mapItem = {
      taskIndex: index,
      rankedPrizeType: item.scoreRankWinConditionDTO.winType,
      rankedPrizeStart: item.scoreRankWinConditionDTO.rankStart,
      rankedPrizeEnd: item.scoreRankWinConditionDTO.rankEnd,
      specifyRanking: item.scoreRankWinConditionDTO.rankNum,
      rankedTitle: "",
    }
    if(that.ruleForm.rankedOpenType == "1"){
      mapItem.rankedPrizeType = 1;
      mapItem.rankedTitle = item.scoreRankWinConditionDTO.rankedTitle;
      mapItem.specifyRanking = "";
    }
    return mapItem;
  })
  return obj;
}
// 活动详情处理参数
export const setBasicInformation = (data, that) => {
  const {
    activityName,
    startTime,
    endTime,
    ruleDto,
    isExposureItem,
    ruleDescription,
    allowLevel,
    crowdIds,
    condFollow,
    templateId,
    isKeyActivity,
    placementPosition,
    isValidBlackList,
    itemList,
    templateJson,
    studentSatus,
  } = data;
  const {
    openCardFollow,
    firstOpenCardTimeType,
    openCardBeforeDay,
    isForceRemind,
    customerPaperwork,
    isCommentLimit, 
  } = ruleDto;
  that.ruleForm.activityName =
    activityName + (that.activityData.isCopy ? "复制" : "");
  that.ruleForm.condFollow = condFollow ? true : false;
  // 活动对象配置
  if (allowLevel == "99") {
    that.peopleSelected = crowdIds.split(",");
    that.actMember = "3";
  } else if (allowLevel == "-1") {
    that.actMember = "1";
    that.ruleForm.partner = ["-1"];
  } else {
    that.actMember = "2";
    if (allowLevel.indexOf("-1") != -1) {
      that.ruleForm.partner = ["-1"];
    } else {
      that.ruleForm.partner = allowLevel.split(",");
    }
  }
  that.ruleForm.studentSatus = studentSatus;
  that.ruleForm.openCardFollow = openCardFollow;
  that.ruleForm.isValidBlackList = isValidBlackList;
  that.ruleForm.firstOpenCardTimeType = firstOpenCardTimeType;
  that.ruleForm.openCardBeforeDay = openCardBeforeDay;
  that.ruleDTO = ruleDto;
  that.isForceRemind = isForceRemind;
  that.isKeyActivity = isKeyActivity || 0;
  that.placementPosition = placementPosition
    ? placementPosition.split(",")
    : ["SHOP"];
  that.ruleForm.orderCompleteLimitCount = ruleDto.orderCompleteLimitCount;
  that.ruleForm.orderCompleteMaxCount = ruleDto.orderCompleteMaxCount;
  that.ruleForm.orderCompleteLimitPayment = ruleDto.orderCompleteLimitPayment;
  that.ruleForm.orderCompleteMaxPayment = ruleDto.orderCompleteMaxPayment;
  that.ruleForm.lastOrderCompleteTimeType =
    ruleDto.lastOrderCompleteTimeType || 0;
  that.ruleForm.lastOrderCompleteStartDay = ruleDto.lastOrderCompleteStartDay;
  that.ruleForm.lastOrderCompleteEndDay = ruleDto.lastOrderCompleteEndDay;
  that.ruleForm.lastOrderCompleteStartTime = ruleDto.lastOrderCompleteStartTime;
  that.ruleForm.lastOrderCompleteEndTime = ruleDto.lastOrderCompleteEndTime;

  console.log("ruleDto",ruleDto,ruleDto.startCommentTime,ruleDto.endCommentTime);
  that.ruleForm.startCommentTime = ruleDto.startCommentTime;
  that.ruleForm.endCommentTime = ruleDto.endCommentTime;
  that.ruleForm.filterType = ruleDto.filterType.toString();
  if (that.ruleForm.filterType == "1") {
    getTaobaoItemListSku({
      current: 1,
      size: ruleDto.skuIdList.length,
      skuIds: ruleDto.skuIdList,
    }).then((result) => {
      that.itemListForFilter = result.data.records;
    });
  }
  that.scores = ruleDto.scores.split(",");
  that.ruleForm.wordNum = ruleDto.wordNum;
  that.ruleForm.imgNum = ruleDto.imgNum;
  that.ruleForm.videoNum = ruleDto.videoNum;
  that.ruleForm.isCommentFilter = ruleDto.isCommentFilter == 1 ? true : false;
  if (that.ruleForm.isCommentFilter) {
    that.ruleForm.commentFilter = ruleDto.commentFilter;
  }else{
    that.ruleForm.commentFilter = "";
  }
  that.ruleDTO.isPreEnter = ruleDto.isPreEnter == 1 ? true : false;
  console.log("ruleDto.isPreEnter",ruleDto.isPreEnter);
  console.log("that.ruleForm.isPreEnter",that.ruleDTO.isPreEnter);
  that.ruleForm.rankedOpenTiming = ruleDto.rankedOpenTiming;
  that.ruleForm.rankedOpenType = ruleDto.rankedOpenType.toString();
  that.changeOpenType()
  that.ruleForm.rankedLimit = ruleDto.rankedLimit;
  that.ruleForm.orderCompleteLimitCount = ruleDto.orderCompleteLimitCount;
  that.ruleForm.orderCompleteMaxCount = ruleDto.orderCompleteMaxCount;
  that.ruleForm.orderCompleteLimitPayment = ruleDto.orderCompleteLimitPayment;
  that.ruleForm.orderCompleteMaxPayment = ruleDto.orderCompleteMaxPayment;
  that.ruleForm.lastOrderCompleteTimeType =
    ruleDto.lastOrderCompleteTimeType || 0;
  that.ruleForm.lastOrderCompleteStartDay = ruleDto.lastOrderCompleteStartDay;
  that.ruleForm.lastOrderCompleteEndDay = ruleDto.lastOrderCompleteEndDay;
  that.ruleForm.lastOrderCompleteStartTime = ruleDto.lastOrderCompleteStartTime;
  that.ruleForm.lastOrderCompleteEndTime = ruleDto.lastOrderCompleteEndTime;

  that.templateJson = JSON.parse(templateJson);
  if (customerPaperwork) {
    that.customerPaperwork = JSON.parse(customerPaperwork);
  }
  // v2.5 => 复制不需要回显奖品和规则
  if (!that.activityData.isCopy) {
    that.ruleForm.startTime = startTime;
    that.ruleForm.endTime = endTime;
    that.activityStartTime = startTime;
    that.activityEndTime = endTime;

    that.ruleForm.isExposureItem = isExposureItem ? true : false;
    that.itemListFor = itemList;
    that.ruleForm.ruleDescription = ruleDescription;
  }
  if (that.activityData.isCopy) {
    that.ruleForm.ruleDescription = "";
  }
  that.templateId = templateId;
};
// 多店铺商品信息
export const useValidateMultiShopGoods = (that,list) => {
  const shopList = that.$store.state.shopList
  return shopList.filter((item)=>{
    return list.includes(item.venderId)
  })
}
